module.exports = __webpack_public_path__ + "img/lock.85dbc3f3.svg";